import Approvals from '../pages/Approvals';
import CWPMaintenance from '../pages/CWPMaintenance';
import CWPMaintenanceAdmin from '../pages/CWPMaintenanceAdmin';
import CWPApproval from '../pages/CWPApproval';
import CWPApprovalCNC from '../pages/CWPApprovalCNC';

const cwpRoute = {
  public: [],
  auth: [
    {
      name: 'approvals_cwp',
      path: '/approvals/cwp',
      permissions: ['KASM', 'SAM', 'DAM'],
      component: Approvals,
    },
    {
      name: 'cwp_maintenance',
      path: '/cwp-maintenance',
      permissions: ['admin', 'KASM', 'SAM'],
      component: CWPMaintenance,
    },
    {
      name: 'cwp_maintenance-deletion-request',
      path: '/cwp-maintenance-deletion-request',
      permissions: ['admin'],
      component: CWPMaintenanceAdmin,
    },
    {
      name: 'cwp_approval',
      path: '/cwp-approval',
      permissions: ['HTAM'],
      component: CWPApproval,
    },
    {
      name: 'cwp_approval',
      path: '/approval/cwp-approval-cnc',
      permissions: ['DAM'],
      component: CWPApprovalCNC,
    },
  ],
};

export default cwpRoute;
